import { createSlice } from "@reduxjs/toolkit";
import {getCouponList } from "./ThunkActions";
import { iCouponState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: iCouponState = {
  isLoading: false,
  couponList: [], // This holds the list of coupons
  errorMessage: null,
};

export const couponSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetCouponState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      // Get coupon list
      .addCase(getCouponList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCouponList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.couponList = payload.data.coupons;
          state.isLoading = false;
        }
      })
      .addCase(getCouponList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })
      
     
  },
});

export const { resetCouponState } = couponSlice.actions;
export default couponSlice.reducer;
